













import { openSelectList } from '@/main/router/routerPath';

import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

type DataType = { STREDNAKL_OZN_ZKT: string; INTR_DRUH_OZN_ZKT: string; TEXT: string };

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'INTR_DRUH_PRP' },
		filter: { type: Object, default: {} },
		ns: { type: Boolean, default: false },
		interDruhNs: { type: Number },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'INTR_DRUH_PRP',
			apiProvider,
			searchValueNs: null as string | null,
			emptyObject: {
				InterDruhNs: null,
				IntrDruhOzn: null,
				IntrDruhOznText: null,
			},
		};
	},
	computed: {
		searchValueNSCmp: {
			get(): string {
				return this.searchValueNs || String(this.interDruhNs);
			},
			set(val: string) {
				this.searchValueNs = val;
			},
		},
	},
	methods: {
		async openGrid() {
			await openSelectList(
				(this as any).storeObject,
				{
					afterRowSelection: this.selected,
					filter: this.filter,
				},
			);
			this.setPageManagerMapper();
		},
		dbToBaseMapper(data: DataType) {
			return {
				InterDruhNs: data.STREDNAKL_OZN_ZKT,
				IntrDruhOzn: data.INTR_DRUH_OZN_ZKT,
				IntrDruhOznText: data.TEXT,
			};
		},
	},
});
